import { Card, CardContent } from "./ui/card";
import { Skeleton } from "./ui/skeleton";

export function KpiCard({ label, value, delta, tone = "neutral", icon: Icon, testid }) {
  const toneClass = tone === "positive" ? "delta-positive" : tone === "negative" ? "delta-negative" : "delta-neutral";
  return (
    <Card className="bg-card border-border" data-testid={testid || "kpi-card"}>
      <CardContent className="p-4">
        <div className="flex items-start justify-between">
          <div className="text-[10px] uppercase tracking-[0.14em] text-muted-foreground">{label}</div>
          {Icon && <Icon size={16} className="text-muted-foreground" />}
        </div>
        <div className="kpi-card-number text-2xl mt-2">{value}</div>
        {delta !== undefined && delta !== null && (
          <div className={`text-[11px] mt-1 tabular-nums ${toneClass}`}>{delta}</div>
        )}
      </CardContent>
    </Card>
  );
}

export function KpiSkeleton({ n = 6 }) {
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
      {Array.from({ length: n }).map((_, i) => (
        <Card key={i} className="bg-card border-border">
          <CardContent className="p-4 space-y-2">
            <Skeleton className="h-3 w-16" />
            <Skeleton className="h-7 w-24" />
            <Skeleton className="h-3 w-20" />
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
